import { useEffect } from 'react';
import {
  Box, LinearProgress, Step, StepLabel, Stepper, Typography, useMediaQuery, useTheme
} from '@mui/material';
import { getAllActiveUsers } from '../../../actions/points';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import ErrorList from '../../ErrorList';
import Loading from '../../Loading';
import Step0 from './Step0';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import StepSuccess from './StepSuccess';

const LABELS = ['Data i czas', 'Osoby', 'Wyniki', 'Kary', 'Komentarz', 'Podsumowanie'];
const SAVING_OFFSET = 100;

const stepFor = (creatorStep: number) => {
  switch (creatorStep) {
    case 0: return <Step0 />;
    case 1: return <Step1 />;
    case 2: return <Step2 />;
    case 3: return <Step3 />;
    case 4: return <Step4 />;
    case 5: return <Step5 />;
    case 6: return <StepSuccess />;
    default: return creatorStep >= SAVING_OFFSET ? <Loading /> : null;
  }
};

export default function AddPoints() {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  // This screen is used almost entirely on a phone, so the six-label stepper is replaced
  // by a one-line indicator rather than made to scroll sideways.
  const compact = useMediaQuery(theme.breakpoints.down('sm'));
  const { creatorStep, errorMessages } = useAppSelector((s) => s.points);

  useEffect(() => {
    dispatch(getAllActiveUsers());
  }, [dispatch]);

  const active = creatorStep >= SAVING_OFFSET ? creatorStep - SAVING_OFFSET : creatorStep;
  const label = LABELS[Math.min(active, LABELS.length - 1)];

  return (
    <div className="addPoints">
      {compact ? (
        <Box sx={{ mb: 2 }}>
          <Typography variant="overline" color="text.secondary">
            Krok {Math.min(active + 1, LABELS.length)} z {LABELS.length} · {label}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={(Math.min(active, LABELS.length) / LABELS.length) * 100}
            sx={{ mt: 0.5, borderRadius: 1 }}
          />
        </Box>
      ) : (
        <Stepper activeStep={active} alternativeLabel sx={{ mb: 3 }}>
          {LABELS.map((step) => (
            <Step key={step}><StepLabel>{step}</StepLabel></Step>
          ))}
        </Stepper>
      )}
      <ErrorList errorMessages={errorMessages} />
      {stepFor(creatorStep)}
    </div>
  );
}
